function formatPrice(price) {
  // Convertir el número a una cadena y agregar puntos como separadores de miles
  return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

export { formatPrice };
